import axios from 'axios';

const runApiProtocol = location.protocol;
const runApiHostname = location.hostname;
const runApiPort = 40690;
const runApiUrl = runApiProtocol + "//" + runApiHostname + ":" + runApiPort + "/v1/";

const envApiUrl = process.env.VUE_APP_API;

var apiUrl = null;

if(envApiUrl){
    apiUrl = envApiUrl;
}else{
    apiUrl = runApiUrl;
}

console.log("API_URL: "+apiUrl);

const api = axios.create({baseURL: apiUrl});

export default api;